var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-post-card"},[_c('div',{staticClass:"image"},[_vm._t("pic")],2),_c('div',{staticClass:"xs-title"},[_vm._t("title")],2),_c('div',{staticClass:"caption"},[_vm._t("desc")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }